<div class="quizzes-page">
  <!-- Header -->
  <div class="page-header">
    <h1>Quizzes</h1>
    <p>Discover and take quizzes created by the community</p>
  </div>

  <!-- Error state -->
  <div class="error-state" *ngIf="error">
    <mat-icon>error</mat-icon>
    <p>{{ error }}</p>
    <button color="primary" mat-raised-button (click)="loadQuizzes()">
      <mat-icon>refresh</mat-icon>
      Retry
    </button>
  </div>

  <!-- Quiz list -->
  <ddc-quiz-list
    [hasMore]="hasMore"
    [loading]="loading"
    [loadingMore]="loadingMore"
    [quizzes]="quizzes"
    (onLoadMore)="onLoadMore()"
    (onQuizClick)="onQuizClick($event.quizId)"
  ></ddc-quiz-list>
</div>
